import GeneralLoader from '../components/GeneralLoader'
import NotAuthenticated from '../components/NotAuthenticated'

import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper'
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
const locationHelper = locationHelperBuilder({})

// ===================================================================================
//  ADMIN
// ===================================================================================
export const adminIsAuthenticated = connectedRouterRedirect({
	// The url to redirect user to if they fail
	redirectPath: '/admin/login',

	// Determine if the user is authenticated or not
	authenticatedSelector: state => {
		// console.log('authenticatedSelector:', state.user.loginChecked.admin)
		return state.user.loginChecked.admin && state.user.admin !== null
	},

	// Component to display while state is being persisted
	AuthenticatingComponent: GeneralLoader,

	// State persistance check (will take a second or so while redux-persist rehydrates)
	authenticatingSelector: state => {
		// console.log('authenticatingSelector:', state.user.loginChecked.admin)
		return !state.user.loginChecked.admin
	},

	// A nice display name for this check
	wrapperDisplayName: 'adminIsAuthenticated'
})

export const adminIsNotAuthenticated = connectedRouterRedirect({
	// This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) && locationHelper.getRedirectQueryParam(ownProps) !== '/admin/logout' ? locationHelper.getRedirectQueryParam(ownProps) : '/admin' 
	},

	// This prevents us from adding the query parameter when we send the user away from the login page
	allowRedirectBack: false,
	
	// Determine if the user is authenticated or not
	authenticatedSelector: state => {
		// console.log(state.user, state.user !== null)
		// console.log('adminIsNotAuthenticated:', state.user === null)
		return state.user.admin === null
	},
	
	// A nice display name for this check
	wrapperDisplayName: 'adminIsNotAuthenticated'
})

export const adminIsAuthenticatedNoLogin = connectedAuthWrapper({
	FailureComponent: NotAuthenticated,
	AuthenticatingComponent: GeneralLoader,
	authenticatedSelector: state => {
		// console.log(state.user.admin)
		return state.user.loginChecked.admin && state.user.admin !== null
	},
	authenticatingSelector: state => {
		return !state.user.loginChecked.admin
	},
	wrapperDisplayName: 'adminIsAuthenticatedNoLogin'
})

// ===================================================================================
//  CUSTOMER
// ===================================================================================
export const customerIsAuthenticated = connectedRouterRedirect({
	redirectPath: '/customer/login',
	authenticatedSelector: state => {
		// console.log('customerIsAuthenticated:', state.user.customer !== null)
		return state.user.customer !== null
	},
	AuthenticatingComponent: GeneralLoader,
	authenticatingSelector: state => !state.persist,
	wrapperDisplayName: 'CustomerIsAuthenticated'
})

export const customerIsNotAuthenticated = connectedRouterRedirect({
	redirectPath: (state, ownProps) => {
		return locationHelper.getRedirectQueryParam(ownProps) && locationHelper.getRedirectQueryParam(ownProps) !== '/customer/logout' ? locationHelper.getRedirectQueryParam(ownProps) : '/customer' 
	},
	allowRedirectBack: false,
	authenticatedSelector: state => {
		// console.log('customerIsNotAuthenticated:', state.user.customer === null)
		return state.user.customer === null
	},
	wrapperDisplayName: 'CustomerIsNotAuthenticated'
})



// WEBPACK FOOTER //
// ./src/shared/auth.js